import { OrdemServico } from '@/types';
import { parseHoursFromAPI } from './ordensServicoTimeUtils';

export const createFallbackOrdemServico = (apiData: any, _error?: Error): OrdemServico => {
  const fallbackId = apiData?.id?.toString() || `error_${Date.now()}_${Math.random()}`;

  return {
    id: fallbackId,
    numero: fallbackId,
    cliente: apiData?.empresa?.nome || apiData?.cliente?.nome || 'Cliente não informado',
    contato: '',
    produto: apiData?.projeto?.nome || apiData?.produto?.nome || 'Produto não informado',
    operador: apiData?.operador?.nome || 'Operador não informado',
    natureza: apiData?.natureza?.descricao || 'Não informado',
    status: 'rascunho',
    dataAbertura: apiData?.data?.real || apiData?.incluido || '',
    dataFechamento: undefined,
    horasExecutadas: parseHoursFromAPI(apiData?.horasTotais),
    horasFaturadas: parseHoursFromAPI(apiData?.horasFaturadas),
    valorTotal: 0,
    valorFaturamento: 0,
    imposto: 0,
    valorAPagar: 0,
    observacoes: apiData?.chamado?.descricao || '',
    empresa: apiData?.empresa?.nome || '',
    projeto: apiData?.projeto?.nome || '',
    tipoProjeto: 'Não',
    incluidoPor: apiData?.operador?.nome || '',
    estatisticasChamado: apiData?.chamado,
  };
};
